import { render, staticRenderFns } from "./blockLayer.vue?vue&type=template&id=1a781ad7"
import script from "./blockLayer.vue?vue&type=script&lang=js"
export * from "./blockLayer.vue?vue&type=script&lang=js"
import style0 from "./blockLayer.vue?vue&type=style&index=0&id=1a781ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports